<template>
  <div>
    <template v-if="complaint">
      <div class="d-flex mb-3 align-items-end">
        <h1 class="h4 primary--text mr-auto">
          {{ $t('navigation.complaint') }}
          <span v-if="complaint.number">
            {{ complaint.number }}
          </span>
        </h1>
      </div>
      <v-card elevation="0">
        <div class="d-flex p-4 border-bottom">
          <div
            v-if="complaint.complaintCode"
            class="mr-4"
          >
            <span class="mr-2 grey--text">{{ $t('common.orders.complaint_code') }}:</span>
            <span>{{ complaint.complaintCode }}</span>
          </div>
          <div v-if="complaint.orderNumber">
            <span class="mr-2 grey--text">{{ $t('common.order_number') }}:</span>
            <span>{{ complaint.orderNumber }}</span>
          </div>
        </div>
        <v-data-table
          class="mb-4"
          fixed-header
          :headers="headers"
          :items="items"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50, 100],
          }"
          :loading="loading"
          :loading-text="$t('common.loading_data')"
        />
        <div class="d-flex p-4 border-top">
          <div class="ml-auto mr-4">
            <span class="mr-2 grey--text">{{ $t('common.total_price') }}:</span>
            <span>{{ complaint.total }}</span>
          </div>
          <div class="mr-4">
            <span class="mr-2 grey--text">{{ $t('common.total_vat') }}:</span>
            <span>{{ complaint.totalVAT }}</span>
          </div>
          <div>
            <span class="mr-2 grey--text">{{ $t('common.total_price_with_vat') }}:</span>
            <span>{{ complaint.totalWithVAT }}</span>
          </div>
        </div>
      </v-card>
      <h1
        v-if="complaint.photos.length"
        class="h5 primary--text mt-10 mb-5"
      >
        {{ $t('common.images') }}
      </h1>
      <div class="complaint-images xl">
        <img
          v-for="(it, i) in complaint.photos"
          :key="it.fileId"
          :src="it.filePath"
          class="cursor-pointer"
          @click="showLightbox(i)"
        >
      </div>
      <vue-easy-lightbox
        :visible="lightboxVisible"
        :imgs="parseLightboxPhotos(complaint.photos)"
        :index="imageIndex"
        @hide="lightboxVisible = false"
      >
        <template v-slot:toolbar="{}">
          <div />
        </template>
      </vue-easy-lightbox>
    </template>
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: 'Complaint',
  components: {
    VueEasyLightbox,
  },
  props: {
    id: String,
  },
  data() {
    return {
      lightboxVisible: false,
      imageIndex: 0,
      items: [],
      loading: false,
      complaint: null,
      headers: [
        {
          text: this.$t('common.article'),
          value: 'code',
        },
        {
          text: this.$t('common.order_name'),
          value: 'name',
        },
        {
          text: this.$t('common.quantity'),
          value: 'quantity',
        },
        {
          text: this.$t('common.order_price'),
          value: 'price',
        },
        {
          text: this.$t('common.VAT_rate'),
          value: 'VATRate',
        },
        {
          text: this.$t('common.discount'),
          value: 'discount',
        },
        {
          text: this.$t('common.order_sum'),
          value: 'sum',
        },
        {
          text: this.$t('common.order_sum_with_vat'),
          value: 'sumWithVAT',
        },
        {
          text: this.$t('common.order_sum_with_vat'),
          value: 'sumWithVAT',
        },
      ],
    };
  },
  created() {
    this.getComplaint();
  },
  methods: {
    async getComplaint() {
      this.loading = true;

      const { data } = await this.$http.get(`complaints/${this.id}`, {
        params: {
          populate: ['photos'],
        },
      }).finally(() => {
        this.loading = false;
      });

      this.complaint = data;
      this.items = data.parts.map((it) => ({ ...it, postComplaintQuantity: 1 }));
    },
    showLightbox(i) {
      this.imageIndex = i;
      this.lightboxVisible = true;
    },
    parseLightboxPhotos(photos) {
      return photos.map((it) => ({
        src: it.filePath,
        title: '',
      }));
    },
  },
};
</script>

<style lang="scss">
  .complaint-images.xl img {
    height: 200px;
    width: 200px;
    margin-right: 12px;
  }
</style>
